import { useEffect, useMemo, useState } from "react";
import useAxios from "../utils/useAxios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useRef } from "react";
import { useAppContext } from "../context/AppContext";
import AsyncSelect from "react-select/async";

function RecurringDonationTab({ donor_id }) {
  // console.log("Current User ID", donor_id);

  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [recurringDonations, setRecurringDonations] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [receiptDetails, setReceiptDetails] = useState({});
  const [role, setRole] = useState(null);
  const [uploadRows, setUploadRows] = useState([]);

  const axiosAPI = useAxios();
  const receiptRef = useRef();
  const fileInputRef = useRef();

  const { state } = useAppContext();
  const { data, loading: donorLoading } = state;

  const fetchRecurringDoantionById = async () => {
    try {
      setLoading(true);
      const response = await axiosAPI.get(
        `/api/donor/get-recurring-donation-by-id/${donor_id}`
      );
      // console.log(response.data.data);
      setRecurringDonations(response.data.data); // Assuming backend returns { data: [...] }
      //   setError("");
    } catch (err) {
      console.error("Error fetching donor gifts:", err);
      //   setError("Failed to fetch gifts.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (donor_id) {
      fetchRecurringDoantionById();
    }
  }, [donor_id]);

  const [formData, setFormData] = useState({
    user_id: "",
    transaction_date_and_time: "",
    amount: "",
    reasonDescription: "",
    reasonCode: "",
    tr_no: "",
  });

  // console.log("Data ", recurringDonations);

  useEffect(() => {
    // const role = JSON.parse(localStorage.getItem("user_role")); // Parses string "admin" to plain string
    setRole(state?.user?.role);
  }, []);

  // Get All Donor Details
  // const getDonorDetails = async () => {
  //   try {
  //     const response = await axiosAPI.get("/api/donor/get-donor-details");
  //     setDonorDetails(response.data.data);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error(error);
  //     setLoading(false);
  //   }
  // };

  function fetchCurrentDateAndTime() {
    const now = new Date();

    // Manually format the date and time to "YYYY-MM-DD HH:MM"
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed, so we add 1
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    // Combine the date and time into the desired format
    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;

    setFormData((prev) => ({
      ...prev,
      transaction_date_and_time: formattedDateTime,
    }));
  }

  // Set current date and time when the form loads
  useEffect(() => {
    fetchCurrentDateAndTime();
  }, []);

  // console.log("Recurring Donation is", recurringDonations);

  const handlePageClick = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setPage(pageNum);
    }
  };

  // useEffect(() => {
  //   // getNotifications();
  //   getDonorDetails();
  // }, []);

  // Handle Input Changes
  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.id]: e.target.value });
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Submit (Add or Edit)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      user_id: formData.user_id?.value,
      transaction_date_and_time: formData.transaction_date_and_time,
      amount: parseInt(formData.amount, 10), //  ensures INT for DB
      reason_description: formData.reasonDescription,
      reason_code: formData.reasonCode,
      tr_no: formData.tr_no,
    };

    // console.log(payload);

    // return;

    try {
      let response;
      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/recurring-donation/update-donation/${currentUserId}`,
          payload
        );
        window.notifyMessage(
          "Success",
          "Donation updated successfully",
          "success"
        );
        //  Local state update kro
        setRecurringDonations((prevDonations) =>
          prevDonations.map((donation) =>
            donation.id === currentUserId
              ? {
                  ...donation,
                  user_id: formData.user_id,
                  transaction_date_and_time: formData.transaction_date_and_time,
                  amount: formData.amount,
                  reason_description: formData.reasonDescription,
                  reason_code: formData.reasonCode,
                  tr_no: formData.tr_no,
                }
              : donation
          )
        );
      } else {
        response = await axiosAPI.post(
          "/api/recurring-donation/add-donation",
          payload
        );
        window.notifyMessage(
          "Success",
          "Donation added successfully",
          "success"
        );
      }
      hideModal("newUserModal");
      // getNotifications();
      //   recurringDonation();
      // fetchCurrentDateAndTime()

      setIsEditMode(false);
      // window.location.reload(); // Reload page to reflect changes in the notification list
      closeModal();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  // Edit Modal Open
  const openEditModal = (id) => {
    setIsEditMode(true);

    // Find the notification with this ID and populate the form
    const selected_recurrer_donation = recurringDonations.find(
      (donor) => donor.id === id
    );

    setCurrentUserId(id);
    // console.log(selected_recurrer_donation);

    if (selected_recurrer_donation) {
      const selectedUser = data.find(
        (user) => user.id === selected_recurrer_donation.user_id
      );

      setFormData({
        user_id: selectedUser
          ? { value: selectedUser?.id, label: selectedUser?.full_name }
          : null,
        transaction_date_and_time:
          selected_recurrer_donation.transaction_date_and_time,
        amount: selected_recurrer_donation.amount,
        reasonDescription: selected_recurrer_donation.reason_description,
        reasonCode: selected_recurrer_donation.reason_code,
        tr_no: selected_recurrer_donation.tr_no,
      });
    }

    showModal("newUserModal");
  };

  const openUploadDonorModal = () => {
    showModal("newUserExcelModal");
  };

  const downloadPdf = () => {
    const input = receiptRef.current;

    html2canvas(input, {
      scale: 2,
      useCORS: true, // Enable CORS to allow external images to be loaded
      allowTaint: true, // Allow tainting the canvas
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`DonationReceipt_${receiptDetails?.full_name || "User"}.pdf`);
    });

    setShowPdfModal(false);
    setReceiptDetails("");
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(
        `/api/notification/delete-notification/${id}`
      );
      window.notifyMessage("Success", "Deleted successfully", "success");
      // getNotifications();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    setUploadRows("");
    setCurrentUserId(null);
  };

  // Helper functions to manage modal visibility
  function hideModal(id) {
    const modal_el = document.querySelector("#" + id);
    const modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      return;
    }

    modal_obj.hide();
  }

  function showModal(id) {
    const modal_el = document.querySelector("#" + id);
    let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      modal_obj = new window.bootstrap.Modal(modal_el, {
        backdrop: "static",
      });
    }

    modal_obj.show();
  }

  const openAddModal = () => {
    showModal("newUserModal");
    fetchCurrentDateAndTime();
  };

  const fetchReceiptDetails = async (id) => {
    try {
      const response = await axiosAPI.get(
        `/api/recurring-donation/download-donation-receipt/${id}`
      );
      // console.log("Reponse",response)
      setReceiptDetails(response.data.user_details);
      // setNotifications(response.data.results);
      // setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const openReceiptModal = (id) => {
    // Find the notification with this ID and populate the form
    const selecteRecurrer = recurringDonations.find((donor) => donor.id === id);

    fetchReceiptDetails(id);
    setShowPdfModal(true);
    // console.log("Receipt", receiptDetails);
  };
  return (
    <div>
      <div className="page-inner">
        {/* Modal */}
        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode
                    ? "Edit Recurring Donation"
                    : "Add Recurring Donation"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Donor Select */}
                  <div className="mb-3">
                    <label htmlFor="user_id" className="form-label">
                      Select Donor
                    </label>
                    <AsyncSelect
                      cacheOptions
                      //   defaultOptions={filteredOptions}
                      //   loadOptions={loadOptions}
                      onChange={(selectedOption) =>
                        setFormData((prev) => ({
                          ...prev,
                          user_id: selectedOption,
                        }))
                      }
                      value={formData.user_id}
                      isClearable
                      placeholder="-- Select Donor --"
                    />
                  </div>

                  {/* Date & Time */}
                  <div className="mb-3">
                    <label
                      htmlFor="transaction_date_and_time"
                      className="form-label"
                    >
                      Date & Time
                    </label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="transaction_date_and_time"
                      name="transaction_date_and_time"
                      value={formData.transaction_date_and_time}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Amount */}
                  <div className="mb-3">
                    <label htmlFor="amount" className="form-label">
                      Amount
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="amount"
                      name="amount"
                      placeholder="Enter Donation Amount"
                      value={formData.amount}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Reason Description */}
                  <div className="mb-3">
                    <label htmlFor="reasonDescription" className="form-label">
                      Reason Description
                    </label>
                    <textarea
                      className="form-control"
                      id="reasonDescription"
                      name="reasonDescription"
                      rows="3"
                      placeholder="Enter Reason Description"
                      value={formData.reasonDescription}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Reason Code */}
                  <div className="mb-3">
                    <label htmlFor="reasonCode" className="form-label">
                      Reason Code
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="reasonCode"
                      name="reasonCode"
                      placeholder="Enter Reason Code"
                      value={formData.reasonCode}
                      onChange={handleChange}
                    />
                  </div>

                  {/* TR No */}
                  <div className="mb-3">
                    <label htmlFor="tr_no" className="form-label">
                      TR No
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="tr_no"
                      name="tr_no"
                      placeholder="Enter tr number"
                      value={formData.tr_no}
                      onChange={handleChange}
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                  >
                    {isEditMode
                      ? "Update Recurring Donation"
                      : "Add Recurring Donation"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Recurring Donation Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <h4 className="card-title mb-0">
                  All Auto Recurring Donations ({recurringDonations.length})
                </h4>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Agency Name</th>
                        <th>Amount</th>
                        <th>Remarks</th>
                        <th>Reason</th>
                        <th>TR NO</th>
                        <th>Date</th>
                        {/* <tr>
                          <th>Action</th>
                          {role === "admin" && (
                               <th>Action</th> // Show this if the role is "admin"
                             )}
                        </tr> */}
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : recurringDonations &&
                        recurringDonations.length > 0 ? (
                        recurringDonations.map((donation) => {
                          const formattedDate = new Date(
                            donation.transaction_date_and_time
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          });

                          return (
                            <tr key={donation.id}>
                              <td>{donation.full_name}</td>
                              <td>{donation.processing_agency}</td>
                              <td>{donation.amount}</td>
                              <td>{donation.reason_description}</td>
                              <td>{donation?.reason_code}</td>
                              <td>{donation?.tr_no}</td>
                              <td>{formattedDate}</td>
                              {/* <td>
                                <button
                                  className="btn btn-dark btn-round btn-icon btn-sm me-2"
                                  onClick={() => openReceiptModal(donation.id)}
                                >
                                  <i className="fas fa-download"></i>
                                </button>
                                {role === "admin" && (
                                  <button
                                    className="btn btn-dark btn-round btn-icon btn-sm me-2"
                                    onClick={() => openEditModal(donation.id)}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                )}
                                {role === "admin" && (
                                     <button
                                       className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                       onClick={() => handleDelete(donation.id)}
                                     >
                                       <i className="fas fa-trash"></i>
                                     </button>
                                   )}
                              </td> */}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <nav aria-label="Page navigation">
              <ul className="pagination flex justify-content-end">
                {/* First Page */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(1)}
                  >
                    First
                  </button>
                </li>

                {/* Previous */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(page - 1)}
                  >
                    Previous
                  </button>
                </li>

                {/* Page Number Buttons in chunks */}
                {(() => {
                  const pageNumbers = [];
                  const maxPagesToShow = 5;
                  const startPage =
                    Math.floor((page - 1) / maxPagesToShow) * maxPagesToShow +
                    1;
                  const endPage = Math.min(
                    startPage + maxPagesToShow - 1,
                    totalPages
                  );

                  for (let i = startPage; i <= endPage; i++) {
                    pageNumbers.push(
                      <li
                        key={i}
                        className={`page-item ${page === i ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageClick(i)}
                        >
                          {i}
                        </button>
                      </li>
                    );
                  }
                  return pageNumbers;
                })()}

                {/* Next */}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(page + 1)}
                  >
                    Next
                  </button>
                </li>

                {/* Last Page */}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(totalPages)}
                  >
                    Last
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecurringDonationTab;
